import React, {
  useState,
  useEffect,
  useCallback,
  forwardRef,
  useImperativeHandle,
  useRef,
  useReducer,
} from "react";
import {
  TextBox,
  Select,
  Checkbox,
  LogoHp,
  Table,
  Button,
  Modal,
  Card,
  InlineNotification
} from "@veneer/core";
import { Row, Col } from "react-bootstrap";
import type { RootState } from '@store/store';
import { useAppSelector, useAppDispatch } from '@store/hooks';
import { useTranslation } from 'react-i18next';
import { columns, PartShippingaddressAddress, partShippingResetFileds } from '@constants/case-create'
import Loader from "@components/home-page/shared-components/loader/loader";
import CustomTable from "@components/shared-components/custom-table/custom-table";
import "./parts-shipping-address-fields.css";
import {
  getFieldError,
  getValidatedNumberInput,
  isValidAddress,
  isValidCityName,
  isValidCompanyName,
  isValidEmail,
  isValidPhoneNumber,
  isValidStateName,
  onSearchDropDown,
  scrollToErrorField,
  validateFields,
  validateName,
  isValidField
} from "../../../../utils";
import { addressvalidatedcountryexclusionlst } from "../../../../resources/exclusion-country-validation";


import { setPartShippingAddressFormValidity } from '@store/reducers/form-part-shipping-address-slice';
import { fetchContactDetails } from "@services/fetch-contact-details-info";
import { HelpModalPopup } from "@components/home-page/shared-components/modal-popup/help-modal-popup";
import { POST_validateaddress } from "@constants/end-points";
import { apiPost } from "@services/service";

import './parts-shipping-address-fields.css'
import { setLoading } from "@store/reducers/loadingSlice";
import { HpLogo } from "@components/home-page/shared-components/hp-logo/hp-logo";

interface PhysicalAddressFieldsProps {
  headerTitle?: string;
  headerContent?: string;
  checkBoxContent?: string;
}

export interface PhysicalAddressFieldsRef {
  submitForm: () => boolean;
}

type partShippingaddressAddress = typeof PartShippingaddressAddress;


const PartsShippingAddressFields = forwardRef<PhysicalAddressFieldsRef, PhysicalAddressFieldsProps>(
  ({ headerTitle, headerContent }, ref) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const formPartShippingAddressData = useAppSelector((state) => state.formPartShippingAddressInfo.formPartShippingAddressData);
    const { savedContactsDropDown, countryList, countryCodes, IsTaxEnabledCountry } = useAppSelector((state: RootState) => state.createCaseAPI);
    const [loaderBtn, setLoaderBtn] = useState(false);
    const [popupTilte, setPopupTitle] = useState<string>("");
    const [open, setOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [errors, setErrors] = useState<partShippingaddressAddress>(PartShippingaddressAddress);
    const [formDetails, setFormDetails] = useState<partShippingaddressAddress>(formPartShippingAddressData);
    const [formTouched, setFormTouched] = useState(false);
    const [disableValidate, setDisableValidate] = useState<boolean>(true);
    const [contryEnable, setContryEnable] = useState<boolean>(false);
    const [modalAddress, setModalAddress] = React.useState<any>([]);
    const [progress, setProgress] = useState<boolean>(false);
    const [filteredCountryList, setFilteredCountryList] = useState(countryList || []);
    const [filteredCountryCodeList, setFilteredCountryCodeList] = useState(countryCodes || []);
    const [isValidateAddressAltClicked, setIsValidateAddressAltClicked] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedAddressRow, setSelectedAddressRow] = useState<any>(null);
    const [isRowSelected, setIsRowSelected] = useState(false);
    const [acceptedSnapshot, setAcceptedSnapshot] = useState<any>(null);
    const [isAcceptFlow, setIsAcceptFlow] = useState(false);
    const PAGE_SIZE = 10;

    const checkBoxContent = t('HPI.CreateCase.HPAcknowledge', { defaultValue: 'By checking this box, I acknowledge HP is not responsible for the loss of data, programs, or my confidential, personal, or proprietary information contained in storage media on the device being shipped.' });

    const defaultRequiredFields = [
      'FirstName', 'LastName', 'countryId', 'PhoneNumber', 'Email',
      'company', 'AddressLine1', 'City', 'State',
      'ZipCode'
      // 'country'
    ];

    const requiredFieldsRef = useRef<string[]>(defaultRequiredFields);

    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const showValidateWarning =
    contryEnable && formDetails.validatedAddressBtn === "on";
    const updateRequiredFields = (updater: (prev: string[]) => string[]) => {
      requiredFieldsRef.current = updater(requiredFieldsRef.current);
      forceUpdate();
    };

    const isSingleUserRole = ['company'];
    const additionalFields = ['equipmentTaxId', 'equipmentTaxOfficeName'];
    const [filteredAltContacts, setFilteredAltContacts] = useState();
    // useEffect(() => {
    //   // If contryEnable is true, make validateBtn a required field
    //   if (contryEnable) {
    //     if (!requiredFieldsRef.current.includes('validateBtn')) {
    //       requiredFieldsRef.current.push('validateBtn');
    //     }
    //   } else {
    //     // Remove validateBtn from required fields
    //     requiredFieldsRef.current = requiredFieldsRef.current.filter(
    //       (field) => field !== 'validateBtn'
    //     );
    //   }
    // }, [contryEnable]);
    useEffect(() => {
      if (savedContactsDropDown.length) {
        let savedContacts: any = [
          {
            label: t("HPI.Dropdown.SelectSavedContact", {
              defaultValue: "create a new contact",
            }),
            value: "-1",
          },
          ...savedContactsDropDown,
        ];
        setFilteredAltContacts(savedContacts);
      }
      if (
        addressvalidatedcountryexclusionlst.some(
          (country: any) =>
            country.toLowerCase() ===
            formDetails?.EquipmentCountryName.toLowerCase()
        )
      ) {
        setContryEnable(true);
      }
    }, []);

    useEffect(() => {
      console.log(window.IsIndividualRole, 'window.IsIndividualRole')
      if (window.IsIndividualRole) {
        updateRequiredFields(prevFields => prevFields.filter(field => !isSingleUserRole.includes(field)));
      }
    }, []);


    useEffect(() => {

      if (formDetails.AddressLine1.length && formDetails.City.length && formDetails.State.length && formDetails.ZipCode.length && formDetails.countryId[0] !== '') {
        setDisableValidate(false)
      } else {
        setDisableValidate(true)
      }

      if (formTouched) {
        const isValid = false;
        dispatch(setPartShippingAddressFormValidity({
          isValid,
          formData: formDetails
        }));
      }

    }, [formDetails]);

    useImperativeHandle(ref, () => ({
      submitForm: () => {
        const isValid = validateForm(formDetails);
        if (isValid) {
          dispatch(setPartShippingAddressFormValidity({ isValid, formData: formDetails }));
        }
        return isValid;
      }
    }));
    useEffect(() => {
          if (!acceptedSnapshot) return;
          if (isAcceptFlow) return;
    
          const isDirty =
            acceptedSnapshot.AddressLine1 !== formDetails.AddressLine1 ||
            acceptedSnapshot.City !== formDetails.City ||
            acceptedSnapshot.State !== formDetails.State ||
            acceptedSnapshot.ZipCode !== formDetails.ZipCode ||
            acceptedSnapshot.countryId !== formDetails.countryId[0];
    
          if (isDirty) {
            setFormDetails((prev) => ({
              ...prev,
              validatedAddressBtn: "on",
            }));
          }
        }, [
          formDetails.AddressLine1,
          formDetails.City,
          formDetails.State,
          formDetails.ZipCode,
          formDetails.countryId,
        ]);
    const fetchContactInfo = useCallback(async (payload: any) => {
      try {
        const data = await fetchContactDetails(dispatch, payload);
        setFormDetails((prevData) => ({ ...prevData, ...data }));
        const isExcluded =
          !!data?.countryName &&
          addressvalidatedcountryexclusionlst.some(
            (country: any) =>
              country.toLowerCase() === data?.countryName.toLowerCase()
          );
           if (isExcluded){
          setFormDetails((prevData) => ({ ...prevData, ['validatedAddressBtn']: "on" }));
        }else{
          setFormDetails((prevData) => ({ ...prevData, ['validatedAddressBtn']: "off" }));

        }
        setFormDetails((prevData) => ({
          ...prevData,
          ["EquipmentCountryName"]: data?.countryName,
        }));

        setContryEnable(isExcluded);
      } catch (err) {
        setContryEnable(false);

        // setError("Failed to load contact details");
      }
    }, []);

    const selectSavedClearHandler = () => {
      setFormDetails((prevData) => ({ ...prevData, ...partShippingResetFileds }));       
    }

    const popupHeader = () => {
      return (
        <p className="popup-header">
          <img
            src="https://logos-world.net/wp-content/uploads/2020/11/HP-Logo.png"
            alt=""
            style={{ height: "46px", width: "auto" }}
          />
          <span>{popupTilte}</span>
        </p>
      );
    };

    const handleCallBack = (title: string) => {
      setPopupTitle(title);
      setIsOpen(true);
    }
     const handleAddressRowSelect = (rowData: any) => {
     setSelectedAddressRow(rowData);
     setIsRowSelected(true);
   };
    const handleAcceptAddress = () => {
      if (!selectedAddressRow) return;

      setIsAcceptFlow(true);
    const acceptedData = {
      AddressLine1: selectedAddressRow.AddressLine1,
      AddressLine2: selectedAddressRow.AddressLine2,
      City: selectedAddressRow.City,
      State: selectedAddressRow.Province,
      ZipCode: selectedAddressRow.PostalCode,
      countryId: [...formDetails.countryId],
   };

      setAcceptedSnapshot({
       ...acceptedData,
        countryId: formDetails.countryId[0],
      });

      setFormDetails((prev) => ({
       ...prev,
       ...acceptedData,
       validatedAddressBtn: "off",
      }));

      setOpen(false);
      setIsRowSelected(false);
      setSelectedAddressRow(null);

      setTimeout(() => setIsAcceptFlow(false), 0);
    };
    const handleRetainClicked = () => {
      setIsAcceptFlow(true);

      const snapshot = {
        AddressLine1: formDetails.AddressLine1,
        AddressLine2: formDetails.AddressLine2,
        City: formDetails.City,
        State: formDetails.State,
        ZipCode: formDetails.ZipCode,
        countryId: formDetails.countryId[0],
      };

      setAcceptedSnapshot(snapshot);

      setFormDetails((prev) => ({
        ...prev,
        validatedAddressBtn: "off",
      }));

      setOpen(false);

      // allow state updates
      setTimeout(() => setIsAcceptFlow(false), 0);
    };
    const onSelectChangeHandler = (selectedOption: any, k: any) => {

      if (selectedOption?.value !== '-1') {
        setFormDetails((prevData) => ({ ...prevData, [k]: [selectedOption?.value] }));
        setFormTouched(true);
        if (k === "country" && selectedOption.value !== "-1") {
          // const isExcluded =addressvalidatedcountryexclusionlst.some((country: any) => country.toLowerCase() === selectedOption.label.toLowerCase());
          //   setContryEnable(isExcluded);
        }
      } else {
        selectSavedClearHandler();
        setFormTouched(false);
        setFormDetails((prevData) => ({ ...prevData, [k]: ['-1'] }));
      }

      if (k === 'UserId' && selectedOption.value !== '-1') {
        setErrors(PartShippingaddressAddress);

        const payload = {
          contactid: selectedOption.value,
        };

        fetchContactInfo(payload);
        setContryEnable(false);

      }

      if (k === 'countryId' && selectedOption.value !== '-1') {
        setFormDetails((prevData) => ({
          ...prevData,
          ["EquipmentCountryName"]: selectedOption?.label,country: selectedOption?.label,
        }));
        const isExcluded = addressvalidatedcountryexclusionlst.some(
          (country: any) =>
            country.toLowerCase() ===
            selectedOption.label.toLowerCase() ||
            country.toLowerCase() ===
            selectedOption.CountryName.toLowerCase()
        );
         if (isExcluded){
          setFormDetails((prevData) => ({ ...prevData, ['validatedAddressBtn']: "on" }));
        }else{
          setFormDetails((prevData) => ({ ...prevData, ['validatedAddressBtn']: "off" }));

        }
        setContryEnable(isExcluded);
        // if (!addressvalidatedcountryexclusionlst.includes(
        //     selectedOption.label.toLowerCase()
        // )
        // ) {
        //     setContryEnable(true);
        // } else {
        //     setContryEnable(false);
        // }

        if (IsTaxEnabledCountry.includes(selectedOption.ShortCode)) {
          updateRequiredFields(prevFields => Array.from(new Set([...prevFields, ...additionalFields])));
          setFormDetails((prevData) => ({ ...prevData, ['partsShippingCountry']: selectedOption.label }));
        } else {
          updateRequiredFields(prevFields => prevFields.filter(field => !additionalFields.includes(field)));
          setFormDetails((prevData) => ({ ...prevData, ['partsShippingCountry']: '' }));
          setFormDetails((prevData) => ({ ...prevData, ['partsShippingTaxId']: '' }));
          setFormDetails((prevData) => ({ ...prevData, ['partsShippingTaxOfficeName']: '' }));
        }

      }

      validateField(k, selectedOption?.value)
    }

    const handleInputChange = (v: any, event: React.ChangeEvent<HTMLInputElement>) => {
      if (!formTouched) setFormTouched(true);
      const { name, value } = event.target;
      setFormDetails((prevData) => ({ ...prevData, [name]: v }));

      if (['PhoneNumber', 'Email'].includes(name)) {
        setErrors((prevState) => ({
          ...prevState,
          [name]: '',
        }));
      } else {
        validateField(name, v);
      }
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      const { name, value } = e.target;
      if (value) {
        validateField(name, value);
      }
    };
     // Pagination logic for Validate address Popup

 
    const pagedData = modalAddress.slice(
      (currentPage - 1) * PAGE_SIZE,
      currentPage * PAGE_SIZE
    );

     const handlePageChange = (direction: "prev" | "next") => {
       setCurrentPage((prevPage) => {
         if (direction === "prev" && prevPage > 1) {
           return prevPage - 1;
         }
         if (
           direction === "next" &&
           currentPage * PAGE_SIZE < modalAddress.length
         ) {
           return prevPage + 1;
         }
         return prevPage;
       });
     };
     // Render the pagination buttons only if necessary
     const totalPages = Math.ceil(modalAddress.length / PAGE_SIZE);

  
    const validateField = (name: string, value: string) => {
      const validations: {
        [key: string]: { fn: (val: string) => boolean; msg: string };
      } = {
        // FirstName: { fn: isValidField, msg: t('HPI.ErrorMessage.InvalidFirstName',{defaultValue:'Invalid First Name'}) },
        // LastName: { fn: isValidField, msg: "Invalid Last Name" },
        Email: {
          fn: isValidEmail,
          msg: t("HPI.ErrorMessage.InvalidEmailFormat", {
            defaultValue: "Invalid email format",
          }),
        },
        PhoneNumber: {
          fn: isValidPhoneNumber,
          msg: t("HPI.ErrorMessage.InvalidNumber", {
            defaultValue:
              "Phone number must be 8-15 digits long and contain only numbers.",
          }),
        },
        // AddressLine1: { fn: isValidField, msg: "Please add a valid Address" },
        // AddressLine2: { fn: isValidField, msg: "Please add a valid Address" },
        // City: { fn: isValidField, msg: "Please add a valid city name." },
        // State: { fn: isValidField, msg: "Please add a valid state name" },
        // company: { fn: isValidField, msg: "Please add a valid company name" },
      };

      let error = "";
      // Skip validation for validateBtn if it's clicked
      // if (name === "validateBtn" && isValidateAddressAltClicked) {
      //   setErrors((prevState) => ({
      //     ...prevState,
      //     [name]: "", // No error for validateBtn once clicked
      //   }));
      //   return;
      // }

      // // Skip validation for validateBtn if it's not enabled
      // if (name === "validateBtn" && !contryEnable) {
      //   return;
      // }
      if (!value) {
        error = t("HPI.ErrorMessage.RequiredFields", {
          defaultValue: "This field is required.",
        });
      } else if (validations[name] && !validations[name].fn(value)) {
        error = validations[name].msg;
      }

      setErrors((prevState) => ({
        ...prevState,
        [name]: error,
      }));
    };

    const validateForm = (formDetails: partShippingaddressAddress) => {
      let formIsValid = true;
      let firstErrorField: string | null = null;
      for (const key in formDetails) {
        if (formDetails.hasOwnProperty(key)) {
          const value = formDetails[key as keyof partShippingaddressAddress];
          const valueToValidate = Array.isArray(value) ? value.join(' ') : value;
          const error = validateFields(key, valueToValidate, requiredFieldsRef.current, t);
          if (error) {
            setErrors((prevState) => ({
              ...prevState,
              [key]: error,
            }));
            formIsValid = false;
            if (!firstErrorField) {
              firstErrorField = key;
            }
          } else {
            if (Array.isArray(formDetails[key as keyof partShippingaddressAddress])) {
              setErrors((prevState) => ({
                ...prevState,
                [key]: [''],
              }));
            } else {
              setErrors((prevState) => ({
                ...prevState,
                [key]: '',
              }));
            }
          }
        }
      }
      if (!formIsValid && firstErrorField) {
        scrollToErrorField(firstErrorField)
      }
      return formIsValid;
    };

    const clearSelectHandler = (field: any) => {
      setFormDetails((prevData) => ({ ...prevData, [field]: ['']
        ,
         ...(field === "countryId"
      ? {
          EquipmentCountryName: "",
          validatedAddressBtn: "off",
        }
      : {}),
       }));
        if (field === "countryId") {
    setContryEnable(false);
  }
      validateField(field, '')
    }

    const onAcknowledgeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!formTouched) setFormTouched(true);
      const { name, checked } = e.target;
      setFormDetails((prevData) => ({ ...prevData, ['Acknowledge']: checked ? 'true' : '' }));
    }

    const clickAbleRowItems = (data: any, items: any) => {
      return (
        <button
          onClick={() => {
            handleRowItemClick(data);
          }}
        >
          {items}
        </button>
      );
    };

    const handleRowItemClick = (data: any) => {
      const selectedData = {
        City: data.City,
        AddressLine1: data.AddressLine1,
        AddressLine2: data.AddressLine2,
        ZipCode: data.PostalCode,
        State: data.Province,

      };
      setFormDetails((prevData) => ({ ...prevData, ...selectedData }));
      setOpen(false);
    };

    const validateAddress = async () => {
      try {
        //setLoaderBtn(true)
        dispatch(setLoading(true));
        setDisableValidate(true);
        setProgress(true)
        let payload = {
          country: formDetails.countryId[0],
          phZipcode: formDetails.ZipCode,
          phState: formDetails.State,
          phCity: formDetails.City,
          addressline1: formDetails.AddressLine1,
        };
        try {
          const getAddress: any = await apiPost(POST_validateaddress, payload);
          // setLoaderBtn(false)
          dispatch(setLoading(false));
          if (getAddress.data) {
            let addresonchange = JSON.parse(getAddress.data.AddressDoctorResult);
            let newAdd = addresonchange.map((items: any) => ({
              ...items,
              AddressLine1:  items.AddressLine1,
              AddressLine2:  items.AddressLine2,
              City: items.City,
              // State: items.Province,
              PostalCode: items.PostalCode,
              Country: items.Country,
            }));
            setModalAddress(newAdd);
            setOpen(true);
            setIsValidateAddressAltClicked(true);
            setDisableValidate(false);
            setProgress(false);
            setFormDetails((prevData) => ({ ...prevData,   ['validatedAddressBtn']: "off" }));
            // setErrors((prevState) => ({ ...prevState, validateBtn: "" }));
          }
        } catch (error) {
          // setLoaderBtn(false)
          dispatch(setLoading(false));
          setDisableValidate(false);
          console.log("Error", error);
        }
      } catch (error) {
        addToast({
          text: `${error}`,
          type: "warning",
          timeout: 15,
          id: 1,
        });
        return false;
        // console.log("error", error);
      }
    };

    return (
      <>
        <Card
          className="card-contact-containerr"
          background="filled"
          content={
            <form>
              {headerTitle ? (
                <div className="">
                  <h4>{headerTitle}</h4>
                  <p>{headerContent}</p>
                  {/* <p className="label-small" id="RequiredFields">
                        Required Fields <span className="text-danger">*</span>{" "}
                    </p> */}
                </div>
              ) : (
                ""
              )}

              <Row className="mt-4">
                {
                  <Col md={6}>
                    <Select
                      options={filteredAltContacts || []}
                      label={`${t(
                        "HPI.CreateCase.Contactinformation.savedContact",
                        { defaultValue: "Saved Contact" }
                      )}${t(
                        "HPI.CreateCase.Contactinformation.choosefromlist",
                        {
                          defaultValue:
                            "Choose a saved contact or create a new contact",
                        }
                      )}`}
                      helperTextVisibility="auto"
                      separateLabel
                      name="UserId"
                      onChange={(selectedOption: any) =>
                        onSelectChangeHandler(selectedOption, "UserId")
                      }
                      value={formDetails?.UserId}
                      placeholder={t("HPI.Dropdown.DefaultText", {
                        defaultValue: "Please select",
                      })}
                      onClear={() => {
                        selectSavedClearHandler();
                      }}
                      {...getFieldError(errors, "UserId")}
                      className="textbox"
                    />
                  </Col>
                }
              </Row>

              <Row>
                <Col md={6}>
                  <TextBox
                    separateLabel
                    label={t("HPI.CreateCase.ShippingContactFirstName", {
                      defaultValue: "Shipping contact first name",
                    })}
                    required
                    name="FirstName"
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterShippingContactFirstName",
                      { defaultValue: "Enter shipping contact first name" }
                    )}
                    onChange={(v: any, e) => handleInputChange(v, e)}
                    value={formDetails.FirstName}
                    error={!!errors.FirstName}
                    helperText={errors.FirstName}
                    className="textbox"
                  />
                </Col>

                <Col md={6}>
                  <TextBox
                    separateLabel
                    label={t("HPI.CreateCase.ShippingContactLastName", {
                      defaultValue: "Shipping contact last name",
                    })}
                    required
                    name="LastName"
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterShippingContactLastName",
                      { defaultValue: "Enter shipping contact last name" }
                    )}
                    onChange={(v: any, e) => handleInputChange(v, e)}
                    value={formDetails.LastName}
                    error={!!errors.LastName}
                    helperText={errors.LastName}
                    className="textbox"
                  />
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Select
                    options={filteredCountryList}
                    showSearch
                    label={t("HPI.CreateCase.address.CountryRegion", {
                      defaultValue: "Country/Region",
                    })}
                    helperTextVisibility="auto"
                    separateLabel
                    required
                    name="countryId"
                    placeholder={t("HPI.ProfilePage.cs.SelectCountry", {
                      defaultValue: "Select country/Region",
                    })}
                    onClear={() => {
                      clearSelectHandler("countryId");
                    }}
                    value={formDetails?.countryId}
                    onSearch={(value: any) => {
                      let filtered: any = onSearchDropDown(
                        countryList,
                        value
                      );
                      setFilteredCountryList(filtered);
                    }}
                    onChange={(selectedOption: any) =>
                      onSelectChangeHandler(selectedOption, "countryId")
                    }
                    {...getFieldError(errors, "countryId")}
                    className="textbox"
                  />
                </Col>


                <Col md={6}>
                  <TextBox
                    value={formDetails.Extension}
                    label={t(
                      "HPI.CreateCase.Contactinformation.Extension",
                      { defaultValue: "Extension" }
                    )}
                    name="Extension"
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterExtension",
                      { defaultValue: "Enter extension" }
                    )}
                    separateLabel
                    className="textbox"
                    onChange={(v: any, e) => {
                      const value = getValidatedNumberInput(v, 5);
                      if (value.length <= 5) {
                        handleInputChange(value, e);
                      }
                    }}
                  />
                </Col>
              </Row>

              <Row>
                <Col lg={2} md={6}>
                  <Select
                    separateLabel
                    options={filteredCountryCodeList}
                    showSearch
                    name="countryId"
                    label={t("HPI.ProfilePage.cs.SelectCountryCode", {
                      defaultValue: "Code",
                    })}
                    placement="bottom"
                    placeholder={t("HPI.ProfilePage.cs.SelectCountryCode", {
                      defaultValue: "Code",
                    })}
                    value={formDetails.countryId}
                    required
                    helperTextVisibility="auto"
                    onClear={() => {
                      clearSelectHandler("countryId");
                    }}
                    onSearch={(value: any) => {
                      let filtered: any = onSearchDropDown(
                        countryCodes,
                        value
                      );
                      setFilteredCountryCodeList(filtered);
                    }}
                    onChange={(selectedOption: any) =>
                      onSelectChangeHandler(selectedOption, "countryId")
                    }
                    {...getFieldError(errors, "countryId")}
                    className="textbox country-code"
                  />
                </Col>
                <Col lg={4} md={6}>
                  <label>
                    {t("HPI.CreateCase.Contactinformation.Phonenumber", {
                      defaultValue: "Phone Number",
                    })}
                  </label>
                  <span className="error">*</span>
                  <HelpModalPopup
                    align={"start"}
                    // id={"modal-popup"}
                    show={isOpen}
                    onClose={() => setIsOpen(false)}
                    title={popupHeader()}
                    callback={() =>
                      handleCallBack(
                        t("HPI.CreateCase.Contactinformation.Phonenumber", {
                          defaultValue: "Phone Number",
                        })
                      )
                    }
                  >
                    <p>
                      {t("HPI.Profilepage.PhoneNumberToolTip.body", {
                        defaultValue:
                          "Please enter no more than 15 numerals, starting with country code (do not use " +
                          " or any other characters)",
                      })}
                    </p>
                  </HelpModalPopup>
                  <TextBox
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterPhoneNumber",
                      { defaultValue: "Enter phone number" }
                    )}
                    required
                    value={formDetails.PhoneNumber}
                    name="PhoneNumber"
                    onChange={(v: any, e) => {
                      const value = getValidatedNumberInput(v, 15);
                      if (value.length <= 15) {
                        handleInputChange(value, e);
                      }
                    }}
                    onBlur={(e) => handleBlur(e)}
                    error={!!errors.PhoneNumber}
                    helperText={errors.PhoneNumber}
                    className="textbox"
                  />
                </Col>
                <Col md={6}>
                  <TextBox
                    separateLabel
                    label={t("HPI.CreateCase.Contactinformation.Email", {
                      defaultValue: "Email",
                    })}
                    type="email"
                    name="Email"
                    required
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterEmail",
                      { defaultValue: "Enter email" }
                    )}
                    value={formDetails.Email}
                    onChange={(v: any, e) => handleInputChange(v, e)}
                    onBlur={(e) => handleBlur(e)}
                    error={!!errors.Email}
                    helperText={errors.Email}
                    className="textbox"
                  />
                </Col>
              </Row>
            </form>
          }
        />
        <Card
          className="card-contact-containerr"
          background="filled"
          content={
            <form>
              <Row>
                {!window.IsIndividualRole && (
                  <Col md={6}>
                    <TextBox
                      separateLabel
                      label={t("HPI.CreateCase.address.Company", {
                        defaultValue: "Company",
                      })}
                      type="text"
                      name="company"
                      required
                      placeholder={t(
                        "HPI.CreateCase.Placeholder.EnterCompany",
                        {
                          defaultValue: "Enter company",
                        }
                      )}
                      value={formDetails.company}
                      onChange={(v: any, e) => handleInputChange(v, e)}
                      error={!!errors.company}
                      helperText={errors.company}
                      className="textbox"
                    />
                  </Col>
                )}

                <Col md={6}>
                  <TextBox
                    separateLabel
                    label={t("HPI.CreateCase.address.Mailstop", {
                      defaultValue: "Mail Stop",
                    })}
                    type="text"
                    name="Mailstop"
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterMailStop",
                      {
                        defaultValue: "Enter mail stop",
                      }
                    )}
                    value={formDetails.Mailstop}
                    onChange={(v: any, e) => handleInputChange(v, e)}
                    className="textbox"
                  />
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <TextBox
                    className="textbox"
                    separateLabel
                    label={t("HPI.CreateCase.address.AddressLine1", {
                      defaultValue: "Address Line 1",
                    })}
                    type="text"
                    name="AddressLine1"
                    required
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterAddressLine1",
                      { defaultValue: "Enter address line 1" }
                    )}
                    onChange={(v: any, e) => handleInputChange(v, e)}
                    value={formDetails.AddressLine1}
                    error={!!errors.AddressLine1}
                    helperText={errors.AddressLine1}
                  />
                </Col>

                <Col md={6}>
                  <TextBox
                    className="textbox"
                    separateLabel
                    label={t("HPI.CreateCase.address.AddressLine2", {
                      defaultValue: "Address Line 2",
                    })}
                    type="text"
                    name="AddressLine2"
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterAddressLine2",
                      { defaultValue: "Enter address line 2" }
                    )}
                    value={formDetails.AddressLine2}
                    onChange={(v: any, e) => handleInputChange(v, e)}
                    error={!!errors.AddressLine2}
                    helperText={errors.AddressLine2}
                  />
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <TextBox
                    separateLabel
                    label={t("HPI.CreateCase.address.City/Town", {
                      defaultValue: "City/Town",
                    })}
                    type="text"
                    required
                    name="City"
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterCity/Town",
                      {
                        defaultValue: "Enter city/town",
                      }
                    )}
                    value={formDetails.City}
                    onChange={(v: any, e) => handleInputChange(v, e)}
                    error={!!errors.City}
                    helperText={errors.City}
                    className="textbox"
                  />
                </Col>
                <Col md={6}>
                  <TextBox
                    separateLabel
                    label={t("HPI.CreateCase.address.State/Province", {
                      defaultValue: "State/Province",
                    })}
                    required
                    type="text"
                    name="State"
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterState/Province",
                      { defaultValue: "Enter state/province" }
                    )}
                    value={formDetails.State}
                    onChange={(v: any, e) => handleInputChange(v, e)}
                    error={!!errors.State}
                    helperText={errors.State}
                    className="textbox"
                  />
                </Col>
              </Row>
              <Row>

              </Row>
              <Row>
                <Col md={6}>
                  <TextBox
                    separateLabel
                    label={t("HPI.CreateCase.address.ZipCode", {
                      defaultValue: "Zip code and Postal code",
                    })}
                    type="text"
                    name="ZipCode"
                    placeholder={t(
                      "HPI.CreateCase.Placeholder.EnterZipCode/postalCode",
                      { defaultValue: "Enter zip code/postal code" }
                    )}
                    value={formDetails.ZipCode}
                    required
                    onChange={(v: any, e) => handleInputChange(v, e)}
                    error={!!errors.ZipCode}
                    helperText={errors.ZipCode}
                    className="textbox"
                  />
                </Col>
                    <Row>
                    <Col md={6}>
                    <Select
                      options={filteredCountryList}
                      showSearch
                      label={t("HPI.CreateCase.address.CountryRegion", {
                        defaultValue: "Country/Region",
                      })}
                      helperTextVisibility="auto"
                      separateLabel
                      name="countryId"
                      required
                      placeholder={t("HPI.ProfilePage.cs.SelectCountry", {
                        defaultValue: "Select country/Region",
                      })}
                      onClear={() => {
                        clearSelectHandler("countryId");
                      }}
                      value={formDetails?.countryId}
                      onSearch={(value: any) => {
                        let filtered: any = onSearchDropDown(
                          countryList,
                          value
                        );
                        setFilteredCountryList(filtered);
                      }}
                      onChange={(selectedOption: any) =>
                        onSelectChangeHandler(selectedOption, "countryId")
                      }
                      {...getFieldError(errors, "countryId")}
                      className="textbox"
                    />
                  </Col>
                </Row>
                {IsTaxEnabledCountry.includes(
                  formDetails?.countryId[0]
                ) && (
                    <Col md={6}>
                      <TextBox
                        separateLabel
                        label={t("HPI.CreateCase.TaxId", {
                          defaultValue: "Tax Id",
                        })}
                        required
                        type="text"
                        name="partsShippingTaxId"
                        placeholder={t(
                          "HPI.CreateCase.Placeholder.EnterTaxId",
                          {
                            defaultValue: "Enter tax Id",
                          }
                        )}
                        value={formDetails.partsShippingTaxId}
                        onChange={(v: any, e) => handleInputChange(v, e)}
                        error={!!errors.partsShippingTaxId}
                        helperText={errors.partsShippingTaxId}
                        className="textbox"
                      />
                    </Col>
                  )}
              </Row>

              {IsTaxEnabledCountry.includes(formDetails?.countryId[0]) && (
                <Row>
                  <Col md={6}>
                    <TextBox
                      separateLabel
                      label={t("HPI.CreateCase.TaxOfficeNames", {
                        defaultValue: "Tax Office Names",
                      })}
                      required
                      type="text"
                      name="partsShippingTaxOfficeName"
                      placeholder={t(
                        "HPI.CreateCase.Placeholder.EnterTaxOfficeNames",
                        { defaultValue: "Enter tax office names" }
                      )}
                      value={formDetails.partsShippingTaxOfficeName}
                      onChange={(v: any, e) => handleInputChange(v, e)}
                      error={!!errors.partsShippingTaxOfficeName}
                      helperText={errors.partsShippingTaxOfficeName}
                      className="textbox"
                    />
                  </Col>
                </Row>
              )}

              {/* <div className="row">
                <div className="col-md-12 checkbox-container">
                  <div>
                    <Checkbox
                      name={formDetails.Acknowledge}
                      onChange={onAcknowledgeHandler}
                      label={checkBoxContent}
                    />
                    {!!errors.Acknowledge && (
                      <label id="checklabel" className="error-text">
                        {" "}
                        {t("HPI.OpenContactCreate.Checkboxpheading", {
                          defaultValue:
                            "You need to acknowledge text above",
                        })}{" "}
                      </label>
                    )}
                  </div>
                </div>
              </div> */}

              <Row>
                <Col>
                  {contryEnable && (
                    <div className="row">
                      <div className="d-flex justify-content-start mt-4">
                        <Button
                          id="btn-submit"
                          disabled={disableValidate}
                          onClick={() => {
                            setIsValidateAddressAltClicked(true);
                            validateAddress();
                          }}
                          type="button"
                          name="validateBtn"
                          className="btn btn-submit"
                        >
                          {loaderBtn ? (
                            <div className="loader-overlay">
                              <div className="loader-css">
                                <Loader />
                              </div>
                            </div>
                          ) : (
                            t("HPI.ValidateAddress", {
                              defaultValue: "Validate Address",
                            }) // Button text when not loading
                          )}
                          {/* {t("HPI.CreateCase.ValidateAddress.header", {
                                defaultValue: "Validate Address",
                              })} */}
                        </Button>
                      </div>
                      <div>
                      {contryEnable && showValidateWarning && (
                          <InlineNotification
                            actionPlacement="top"
                            closeButton={true}
                            customStyle={{
                              width: "40%",
                              marginTop: "10px"
                            }}
                            description={t("HPI.ValidateAddress.error", {
                              defaultValue: "Please click on validate address button before case submission.",
                            }
                            )}
                            type="negative"
                          />
                      )}
                    </div>
                    </div>
                  )}
                  <Modal
                    className="validate-address-modal"
                    id="modal-id"
                    show={open}
                    header={
                      <div className="popup-header" style={{ display: "flex" }}>
                        <HpLogo />
                        <h3 className="mt-4"> {t("HPI.Profilepage.myprofile.Address", { defaultValue: 'Address' })}</h3>
                      </div>
                    }
                  >
                   {pagedData.length > 0 ? (
                        <CustomTable
                          key={currentPage}
                          columns={columns}
                          data={pagedData}
                          onRowSelect={handleAddressRowSelect}
                        />
                      ) : (
                        <div className="text-center py-4">
                          <h3>No records found</h3>
                        </div>
                      )}
                    {modalAddress.length > PAGE_SIZE && (
                      <div className="d-flex justify-content-end mt-3 gap-2">
                        <Button
                          appearance="secondary"
                          disabled={currentPage === 1}
                          onClick={() => handlePageChange('prev')}>Prev </Button>
                    
                        <Button
                          appearance="secondary"
                          disabled={currentPage === totalPages}
                          onClick={() => handlePageChange('next')} >Next </Button>
                      </div>
                    )}
                    <div className="mt-4 d-flex align-items-center gap-3">
                      <Button
                        id="btn-cancel"
                        appearance="secondary"
                        onClick={handleRetainClicked}
                      >
                        Retain existing
                      </Button>
                      <Button
                        appearance="primary"
                        disabled={!isRowSelected || modalAddress.length === 0}
                        onClick={handleAcceptAddress}
                      >
                        Accept
                      </Button>
                    </div>
                  </Modal>
                </Col>
              </Row>
            </form>
          }
        />
      </>
    );
  });

export default PartsShippingAddressFields;

function addToast(arg0: { text: string; type: string; timeout: number; id: number; }) {
  throw new Error("Function not implemented.");
}